import { ILocaleLegacy } from '@locales/interfaces';

/**
 * @deprecated
 * @todo
 * These are legacy translations. Some of them are used silently (come from BE), while others are outdated.
 * Please remove keys if you are 100% sure that they are not used in the project anymore.
 */
export const ms = {
  IBCorporate: 'IB Korporat',
  IBIndividual: 'IB Individu',
  MAMIndividual: 'MAM Individu',
  MAMMasterWithLPOA: 'MAM Individu',
  MarkupConfirmation: 'Pengesahan Markup',
  UserCorporate: 'User Corporate',
  UserIndividual: 'User Individual',
  UserJoint: 'User Joint',
  account: {
    bankingDetails: 'Butiran Perbankan',
    createANewAccount: 'Buka akaun baru',
    register: 'Daftar',
    registerSignInTitle: 'Sudah mendaftar?',
  },
  admin: {
    user: {
      fields: {
        isMam: 'Is MAM',
        isSales: 'Is Sales User',
      },
    },
    tabs: {
      tradingSettings: {
        tradingAccountSettings: 'Trading Account Settings',
        setIBCode: 'Set IB Code',
      },
    },
    reports: {
      ftdUtmReport: {
        headerTitle: 'FTD_UTM Report',
        menuTitle: 'FTD_UTM Report',
      },
    },
  },
  adminSocialTrading: {
    title: 'Perdagangan Sosial',
    investorAccountDetails: {
      tradingAccountName: 'Nama akaun dagangan',
      balance: 'Baki',
      login: 'Log Masuk',
    },
    masterAccountDetails: {
      copyType: 'Jenis Salinan',
      groupMappingType: 'Group Mapping Type',
      login: 'Log Masuk',
    },
  },
  backgroundJobs: {
    recurring: {
      title: 'Recurring Jobs',
    },
  },
  bonuses: {
    collectBirthdayGift: 'Dapatkan hadiah hari jadi anda',
    availableTable: {
      bonusSize: 'Saiz Bonus',
    },
  },
  errors: {
    shared: {
      recordWasNotFound: 'Rekod tidak dijumpai',
    },
    captcha: {
      captchaServerIsUnavailable:
        'Server Captcha tidak tersedia. Sila muat semula halaman dan cuba lagi. Sekiranya masalah masih berlaku, hubungi khidmat sokongan melalui live chat atau melalui e-mel {{0}}',
    },
    files: {
      fileWasNotUploaded: 'File was not loaded',
    },
    mam: {
      linkIsInactive: 'Used link is not active',
    },
    trading: {
      profitSharingLimitWasExceeded:
        'Sila ambil perhatian, bahawa had maksimum untuk perkongsian keuntungan telah melebihi. Had maksimum ialah {{0}}%.',
      notEnoughMoney:
        'Maaf, tetapi anda tidak mempunyai cukup dana dalam akaun dagangan anda untuk memproses pengeluaran yang diminta. Sila pastikan anda mempunyai baki yang mencukupi sebelum mencuba pengeluaran. Sila ambil perhatian bahawa selain daripada baki yang ada, anda juga perlu mengambil kira tahap margin percuma yang diperlukan untuk pengeluaran.',
    },
    copyTrading: {
      equityIsLessOrEqualZero: 'Akaun Master tidak layak untuk disalin pada masa ini, sila cuba sebentar lagi',
    },
    securityCode: {
      emptyValue: 'Nilai keselamatan yang dimasukkan (kata laluan atau kod PIN) tidak boleh kosong atau nol',
      invalidLength: 'Nilai keselamatan yang dimasukkan (kata laluan atau kod PIN) mesti mengandungi {{0}} aksara',
      invalidMinLength:
        'Nilai keselamatan yang dimasukkan (kata laluan atau kod PIN) mesti mengandungi sekurang-kurangnya {{0}} aksara',
      invalidMaxLength:
        'Nilai keselamatan yang dimasukkan (kata laluan atau kod PIN) tidak boleh melebihi {{0}} aksara',
      manyRepeatedValues:
        'Nilai keselamatan yang dimasukkan (kata laluan atau kod PIN) tidak boleh mempunyai lebih daripada {{0}} aksara berulang',
      missingNumericValues:
        'Nilai keselamatan yang dimasukkan (kata laluan atau kod PIN) mesti mengandungi aksara nombor',
      containsNumericValues:
        'Nilai keselamatan yang dimasukkan (kata laluan atau kod PIN) tidak boleh mengandungi sebarang nilai nombor',
      missingLowerCaseValues:
        'Nilai keselamatan yang dimasukkan (kata laluan atau kod PIN) mesti mengandungi aksara kecil',
      containsLowerCaseValues:
        'Nilai keselamatan yang dimasukkan (kata laluan atau kod PIN) tidak boleh mengandungi sebarang nilai aksara kecil',
      missingUpperCaseValues:
        'Nilai keselamatan yang dimasukkan (kata laluan atau kod PIN) mesti mengandungi aksara besar',
      containsUpperCaseValues:
        'Nilai keselamatan yang dimasukkan (kata laluan atau kod PIN) tidak boleh mengandungi sebarang nilai aksara besar',
      missingSpecialValues:
        'Nilai keselamatan yang dimasukkan (kata laluan atau kod PIN) mesti mengandungi aksara khas',
      containsSpecialValues:
        'Nilai keselamatan yang dimasukkan (kata laluan atau kod PIN) tidak boleh mengandungi sebarang nilai aksara khas',
      passwordChangeLimit: 'Password change attempts limit is exceeded. Please wait and try again',
    },
    user: {
      accountHasBeenDisabled: 'Maaf atas kesulitan, akaun {{0}} telah dinyahaktif',
      ageIsAboveMaxAllowed: 'Kami tidak menerima pemohon yang berumur di bawah {{0}} tahun dan di atas {{1}} tahun.',
      ageIsUnderMinAllowed: 'Kami tidak menerima pemohon yang berumur di bawah {{0}} tahun.',
      cantChangeLanguage: 'Cannot change language',
      fieldIsRequired: 'Medan {{0}} diperlukan',
      ibCodeIsIncorrect: "Kod IB '{{0}}' salah. Sila masukkan kod IB yang betul",
      invalidCredentials: 'Nama pengguna {{0}} dan/atau kata laluan tidak sah',
      invalidLengthOfPhoneNumber: 'Bilangan nombor telefon tidak sah, sila cuba lagi',
      invalidLink: 'Pautan tidak sah',
      invalidPhoneNumberLength: 'Bilangan nombor telefon tidak sah, sila cuba lagi',
      onlyLatinCharactersAndDigitsAndSpecialSymbolsCanBeUsed:
        'Only latin characters, digits and special symbols can be used for {0} field',
      onlyLatinCharactersAndDigitsCanBeUsed: 'Kami tidak menerima pemohon yang berumur di bawah {{0}} tahun.',
      onlyLatinCharactersCanBeUsed: 'Hanya aksara latin boleh digunakan untuk medan {{0}}.',
      onlyChineseCharactersCanBeUsed: 'Only chinese characters can be used for {{0}} field',
      personalDataNotEntered: 'Personal data are not entered',
      userCannotBeRestored:
        'Sorry, the record cannot be restored as the email or phone number of this profile is already in use with another profile, please delete the profile with the same email or phone number to restore this one',
      userDoesntExist: 'Pengguna {{0}} tidak wujud',
      userEmailAlreadyExists: 'Emel telah berdaftar di dalam sistem',
      userPhoneAlreadyExists: 'Telefon pengguna telah berdaftar di dalam sistem',
      cantUpdateProfileActualStatus: 'Kemas kini akaun gagal {{0}}, status = {{1}}',
    },
  },
  formats: {
    formatFloat: '{{value, float}}',
    formatMoney: '{{value, money}}',
  },
  forms: {
    dragFile: 'atau tarik fail ke sini',
    exportFormat: 'Format Eksport',
    getCode: 'Dapatkan kod',
    hide: 'Sembunyi',
    limitMessage: '{{limit}} karakter lagi',
    resend: 'Hantar semula',
    seconds: 'sec',
    show: 'Tunjuk',
  },
  headerWithBalance: {
    serverTime: 'Waktu Pelayan',
    failedToFetchServerTime: 'Gagal mendapatkan waktu pelayan',
    view: 'Paparan',
  },
  investors: {
    blackList: 'Senarai Hitam',
  },
  legal: {
    clientAgreement: 'Perjanjian Pelanggan',
    privacyPolicy: 'Dasar Privasi',
  },
  legalTradingPlatform: {
    data: 'Data',
  },
  masterProfile: {
    aboutMaster: 'About Master',
    infoFields: {
      ibCode: 'IB code',
    },
  },
  masters: {
    fields: {
      masterNickname: 'Nama panggilan Master',
      rating: 'Kedudukan dalam senarai',
    },
  },
  menu: {
    deposit: 'Deposit',
  },
  messages: {
    CopyTrading: {
      InvestorAccountWasLinked: "Akaun pengikut mula menyalin akaun Master '{{MasterAccountName}}'.",
      InvestorAccountWasOpened:
        "Akaun pengikut telah dibuat. Akaun pengikut mula menyalin akaun Master '{{InvestorAccountName}}'.",
      InvestorAccountWasUnlinked: "Akaun pengikut berhenti untuk menyalin akaun Master '{{MasterAccountName}}'.",
      MasterAccountWasChanged:
        'Akaun master telah diubah suai. (Perkongsian keuntungan={{ProfitSharing}}, Kaedah Peruntukan={{AllocationMethod}})',
      MasterAccountWasLinked: "Akaun pengikut '{{InvestorAccountName}}' mula menyalin akaun Master.",
      MasterAccountWasOpened:
        'Akaun master telah dibuat. (Perkongsian keuntungan={{ProfitSharing}}, Kaedah Peruntukan={{AllocationMethod}})',
      MasterAccountWasUnlinked: "Akaun pengikut '{{InvestorAccountName}}' berhenti untuk menyalin akaun Master.",
    },
  },
  modal: {
    error: 'Ralat',
    notification: 'Notification',
    ok: 'Ok',
  },
  operationHistory: {
    filterName: 'Cari',
    placeholder: 'Sila masukkan',
  },
  pageTitles: {
    admin: {
      financialIdentity: {
        children: {
          cards: 'Cards',
        },
      },
    },
  },
  partnership: {
    salesTitle: 'Jualan',
    ibInfo: {
      detailsTitle: 'Butiran IB',
      nextRebatePayment: 'Bayaran Rebat Seterusnya',
      statistics: {
        closetTradersReport: {
          type: 'Jenis',
        },
        tradingVolReport: {
          subIb: 'Sub-IB',
        },
      },
    },
    ibSettings: {
      referralLinkError: 'Penanda tidak betul! Sila hubungi pasukan sokongan kami untuk mendapatkan penanda yang betul',
    },
    salesUserInfo: {
      aeCode: 'Kod AE',
    },
  },
  profile: {
    adult: 'Saya berumur lebih 18 tahun',
    code: 'Kod',
    country: 'Negara',
    documentsUploaded: 'Dokumen Yang Dimuat Naik',
    isAgreeWithTermsAndConditions: 'Saya bersetuju dengan <0>Terma dan Syarat</0> dan <1>Dasar Privasi</1>',
    pleaseValidateAccountToDeposit:
      'Butiran peribadi anda perlu disahkan oleh pasukan pematuhan {{brokerName}}. Sebelum melakukan deposit, anda perlu menghantar satu salinan ID anda',
    successChangeDescription: 'Changes are saved!',
    warningMessage: {
      profileIsBeingVerified: 'Your profile is being verified, it might take a couple of seconds',
    },
  },
  psp: {
    accountsFetchFailErr: 'Gagal mendapatkan akaun',
    confirmEveryTransaction: 'Sahkan setiap transaksi, deposit boleh mengambil masa sehingga 24 jam',
    deposit: {
      depositForm: {
        accountNameTitle: 'Nama Akaun',
        addressLine2: 'Address Line 2',
        beneficiaryAccountNumberTitle: 'Nombor Akaun Bank',
        beneficiaryBankHint: 'Sila pilih nombor akaun bank',
        beneficiaryBankNameHint: 'Nama Bank, Cth. (Standard Charted Bank)',
        cardNameTitle: 'Card Name',
        localDepositFileHint: 'Sila sertakan dokumen pengesahan bayaran',
      },
      depositTitle: 'Deposit Dana',
      notice: 'Makluman! Pengeluaran hanya untuk akaun yang telah disahkan',
      warnToSubmitPersonalDetails:
        'Untuk melakukan deposit, sila hantar butiran peribadi anda. Pastikan data tersebut sesuai dengan data dalam ID anda',
    },
    localAgentTable: {
      login: 'Log Masuk',
    },
    operationsFetchFailErr: 'Gagal mendapatkan operasi',
    operationsTable: {
      documentTitle: 'Dokumen',
      operationsTableTitle: 'Operasi Terkini',
      paymentSystemTitle: 'Sistem Pembayaran',
    },
    pluginInfoFetchFailErr: 'Gagal mendapatkan info plugin',
    pluginNotFound: 'Plugin tidak dijumpai',
    pluginsFetchFailErr: 'Gagal mendapatkan plugin',
    preAuthorizedBanking: 'Pre-Authorized Banking',
    qrCodeCryptoNotice:
      'The QR Code is for one-time only. Do not scan this code in crypto application more than once, otherwise your payment will be suspended.',
    qrCodeCryptoTitle: 'QR Code for crypto application',
    resentOperationsTitle: 'Operasi Terkini',
    transfer: {
      transactionDetailsTitle: 'Butiran transaksi',
      transferForm: {
        amountError: 'Lebih dari jumlah yang boleh dipindahkan',
        currencyTitle: 'Mata wang',
      },
    },
    uploadBankStatementWithBankName:
      'Muat naik penyata bank yang mengandungi Nama Bank, Nama Penuh dan Nombor Akaun Bank Anda',
    uploadPayslip: 'Upload the bank payslip of your deposit',
    uploadYourDocument: 'Please confirm your deposit by uploading your bank statement',
    withdrawal: {
      notice: 'Pengeluaran disediakan untuk akaun yang disahkan sahaja',
      withdrawalTitle: 'Pengeluaran Dana',
      withdrawalForm: {
        bankNameTitle: 'Nama Bank',
        beneficiaryCryptoWalletHint: 'A wallet number with cryptocurrency money will be sent to',
        beneficiaryCryptoWalletTitle: 'Beneficiary Crypto Wallet',
        confirmTitle: 'Sahkan Maklumat Pengeluaran',
      },
    },
  },
  settings: {
    docsForm: {
      documentNumberHint: 'Semak jika nombor pengenalan sama seperti dalam gambar',
      documentTypeHint:
        'Sila pastikan anda menghantar satu salinan imbas atau gambar dokumen sah yang berkualiti tinggi',
      uploadedDocumentsTable: {
        docNameTitle: 'Nama Dokumen',
        documentNumber: 'Nombor Dokumen',
        typeTitle: 'Jenis Dokumen',
      },
    },
    profileForm: {
      editProfileTitle: 'Ubah profil',
      proceedToDeposit: 'Terus ke Deposit',
      saveUserSuccessMessage: 'Profil berjaya disimpan',
      userDetailsErrorMessage: 'Gagal mendapatkan profil pengguna',
      verifyPersonalDetails: 'Pengesahan maklumat peribadi',
      verifyProfileBtn: 'Sahkan Profil',
    },
  },
  socialTradingModal: {
    copyHint:
      'Akaun {{account}} anda akan berhenti menyalin Master {{oldMaster}} dan akan mula menyalin Master {{newMaster}}',
  },
  tradingAccounts: {
    accountDetailsTitle: 'Akaun Dagangan',
    accountHistoryForm: {
      closeTimeTitle: 'Waktu Tutup',
    },
    changeTradingAccountName: 'Tukar nama akaun dagangan',
    connectedAccounts: 'Akaun Disambungkan',
    currency: 'Mata Wang',
    depositForm: {
      amountTitle: 'Jumlah',
      errorMessage: 'Deposit tidak berjaya',
      successMessage: 'Deposit berjaya dilakukan',
    },
    descriptionPlaceholder: 'Masukkan pengesyoran untuk pengikut anda',
    fetchServersErr: 'Gagal mendapatkan pelayan',
    ibCode: 'IB (tidak wajib)',
    notRows: 'Tiada baris untuk dipaparkan',
    openAccountModalSubTitle: 'Instrumen dagangan yang pelbagai: mata wang, logam. Terma dagangan standard.',
    tradingPlatforms: 'Platform Dagangan',
    transferForm: {
      title: 'Pindah Dana',
    },
    withdrawForm: {
      amountTitle: 'Jumlah',
      errorMessage: 'Gagal menyimpan leveraj',
      successMessage: 'Pengeluaran berjaya dilakukan',
    },
  },
} satisfies ILocaleLegacy;
